
import DesktopGallery from "@/sliders/desktopSlider"
import MobileSlider from "@/sliders/mobileSlider"



export default async () => {
  // gallery

  // HIDE SSR GALLERY ON MOBILE

  document.querySelector("section.tf-gallerie").classList.add("d-none")
  document.querySelector("section.tf-gallerie").classList.add("d-md-block")


  // GET SOURCE OBJECTS (objects from SSR that contain src's to images of different resolutions, e.g. imgSmall, imgMedium, imgLarge, imgXL, etc.)
  // For more information, check this documentation: https://travelfactory.atlassian.net/wiki/spaces/TA/pages/2766929939/Images+Flow

  let srcObjectArray = [];

  let liheImages = []
  if (window.seasonManager.isWinter()) {
    liheImages = window.lihe["picturesLodgingWinter"] || window.lihe["picturesLodging"]

  } else if (window.seasonManager.isSummer()) {
    liheImages = window.lihe["picturesLodgingSummer"] || window.lihe["picturesLodging"]
  } else {
    throw new Error("season in hash is mandatory, make sure the decideSeason function runs before this")
  }

  const prestImageArrays = window.lihe.prestations.map((prestObj => prestObj.picturesAccomodation))
  const prestImages = prestImageArrays.flat()
  const srcObjectArrayWithAllImages = [...liheImages, ...prestImages]

  // Removing duplicated images
  let set = new Set();
  for (let obj of srcObjectArrayWithAllImages) {
    // Convert the object to a string to use as the Set key
    const objStr = JSON.stringify(obj);
    
    // If the object hasn't been added to the Set yet, add it to the unique array
    if (!set.has(objStr)) {
      set.add(objStr);
      srcObjectArray.push(obj);
    }
  }

  // add types to images
  srcObjectArray = srcObjectArray.map((obj => {
    return {
      ...obj,
      type: 'image'
    }
  }))


  // insert youtube video into source objects array
  const indexOfYoutubeVideo = 2
  if (window.lihe.id_youtube_ts) {
    const obj = {
      type: "video_youtube",
      src: window.lihe.id_youtube_ts
    }
    if (srcObjectArray.length <= indexOfYoutubeVideo) {
      srcObjectArray.push(obj)
    } else {
      srcObjectArray.splice(indexOfYoutubeVideo, 0, obj)
    }
  }


  // INSTANTIATE DESKTOP OR MOBILE GALLERIES
  if (window.screenSizeManager.screenType!=='desktop') {
    window.gallerySliderMobile = new MobileSlider(
      srcObjectArray, undefined, "#tf-gallerie-slider-mobile"
    )
    window.gallerySliderMobile.init()
  } else {
  // selectors of elements that on click should open the gallery
  const activatingSelectors = [".gallery-tile .gallery-img", "#tf-see-all-photos"]
  Array.from(activatingSelectors).forEach((activatingSelector) => {
    const elems = document.querySelectorAll(activatingSelector)
    elems.forEach((elem) => {
      elem.addEventListener('click', () => {
        if (!window.gallerySliderDesktop) {
          window.gallerySliderDesktop = new DesktopGallery(
            "gallery-slider-desktop",
            "#tf-gallerie-slider-desktop",
            srcObjectArray,
            activatingSelectors
          )

          window.gallerySliderDesktop.init()
          elem.click()
        }
      })
    })
  })

  }

}